import { FormRenderProps } from 'react-final-form';
import {
  Stack,
  Flex,
  Button,
  Input,
  Textarea,
  Checkbox,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

import FieldWrapper from '@/components/common/FieldWrapper';
import { SchemaType } from './schema';

const ContactForm = ({
  handleSubmit,
  id,
  submitting,
  pristine,
}: FormRenderProps<SchemaType> & { id?: string }) => {
  const { t } = useTranslation('backoffice');

  return (
    <form noValidate style={{ width: '100%' }} onSubmit={handleSubmit} id={id}>
      <Stack>
        <FieldWrapper name="sender_name" label={t('name', 'Nimi')} isRequired>
          {({ input }) => <Input {...input} />}
        </FieldWrapper>
        <FieldWrapper
          name="sender_phone"
          label={t('phone_number', 'Puhelinnumero')}
          isRequired
        >
          {({ input }) => <Input {...input} />}
        </FieldWrapper>
        <FieldWrapper
          name="sender_email"
          label={t('email', 'Sähköposti')}
          isRequired
        >
          {({ input }) => <Input {...input} />}
        </FieldWrapper>
        <FieldWrapper
          name="sender_message"
          label={t('message', 'Viesti')}
          isRequired
        >
          {({ input }) => <Textarea {...input} backgroundColor="white" />}
        </FieldWrapper>
        <FieldWrapper name="publish_consent" type="checkbox">
          {({ input }) => (
            <Checkbox
              {...input}
              isChecked={input.checked}
              type="checkbox"
              colorScheme="primary"
            >
              {t(
                'permission_to_publish_question_online',
                'Kysymykseni saa julkaista tällä sivulla välittäjän vastauksen yhteydessä (nimeäsi tai yhteystietojasi ei julkaista)',
              )}
            </Checkbox>
          )}
        </FieldWrapper>
        <FieldWrapper name="marketing_consent" type="checkbox">
          {({ input }) => (
            <Checkbox
              {...input}
              isChecked={input.checked}
              type="checkbox"
              colorScheme="primary"
            >
              {t(
                'i_want_subscribe_to_marketing_via_email',
                'Minulle saa lähettää markkinointiviestejä sähköpostitse',
              )}
            </Checkbox>
          )}
        </FieldWrapper>
        <Flex justifyContent="flex-start">
          <Button
            size="md"
            colorScheme="primary"
            type="submit"
            isLoading={submitting}
            isDisabled={pristine}
          >
            {t('send_message', 'Lähetä viesti')}
          </Button>
        </Flex>
      </Stack>
    </form>
  );
};

export default ContactForm;
